import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import Shell from '../../dashboard/Shell';
import TaskPlanner from './TaskPlanner';
import './TaskPlannerPage.css';

const TaskPlannerPage = () => {
  return (
    <Shell>
      <div className="rstp-page">
        <header className="rstp-page__head">
          <Link to="/overview" className="rstp-page__back" aria-label="Back to overview">
            <ChevronLeft size={18} aria-hidden="true" />
            <span>Back</span>
          </Link>
          <div className="rstp-page__title">
            <span className="rstp-page__eyebrow">Utilities</span>
            <h1 className="rstp-page__heading">Tasks &amp; Calendar</h1>
            <p className="rstp-page__sub">Plan your week, knock things off, keep moving.</p>
          </div>
        </header>

        <div className="rstp-page__body">
          <div className="rstp-page__card">
            <TaskPlanner splitView />
          </div>
        </div>
      </div>
    </Shell>
  );
};

export default TaskPlannerPage;
